// Lib
import gql from 'graphql-tag';

// Types
import {
  ORGANIZATION_MEMBER,
  ORGANIZATION_PAYMENT_DETAILS,
  ORGANIZATION_ROLE,
  ORGANIZATION_SHIPPING_DETAILS,
} from '../types';

export const organizationMemberList = gql`
  query OrganizationMemberList($input: OrganizationMemberListInput!) {
    organizationMemberList(input: $input) {
      limit
      cursor
      hasMore
      items {
        ${ORGANIZATION_MEMBER}
      }
    }
  }
`;

export const organizationRoleList = gql`
  query OrganizationRoleList($input: OrganizationRoleListInput!) {
    organizationRoleList(input: $input) {
      limit
      cursor
      hasMore
      items {
        ${ORGANIZATION_ROLE}
      }
    }
  }
`;

export const organizationPaymentDetailsList = gql`
  query OrganizationPaymentDetailsList($input: OrganizationPaymentDetailsListInput!) {
    organizationPaymentDetailsList(input: $input) {
      hasMore
      items {
        ${ORGANIZATION_PAYMENT_DETAILS}
      }
    }
  }
`;

export const organizationShippingDetailsList = gql`
  query OrganizationShippingDetailsList($input: OrganizationShippingDetailsListInput!) {
    organizationShippingDetailsList(input: $input) {
      hasMore
      items {
        ${ORGANIZATION_SHIPPING_DETAILS}
      }
    }
  }
`;

export const pendingOrganizationInvitationsQuery = gql`
  query PendingOrganizationInvitations {
    pendingOrganizationInvitations {
      invitationId
      organizationId
      organizationName
      organizationAvatar {
        url
      }
      roleType
      invitedAt
    }
  }
`;

export const workspaceLandingDestinationQuery = gql`
  query WorkspaceLandingDestination {
    workspaceLandingDestination
  }
`;

/** Onboarding prefill: social profiles linked from a website (account session, no org needed). */
export const websiteSocialProfilesQuery = gql`
  query WebsiteSocialProfiles($url: String!) {
    websiteSocialProfiles(url: $url) {
      websiteUrl
      youtube
      instagram
      tiktok
    }
  }
`;
